import { useState } from 'react';
import { X } from 'lucide-react';

import { HoursStepper } from './HoursStepper';
import type { PlanHoursRowProps } from './types';

// One holder of the plan: its figures are the fields that change them, saved as
// each one settles. The new figure shows while the server answers.
export function PlanHoursRow({ label, name, fixed, variable, onSave, remove }: PlanHoursRowProps) {
  const [pending, setPending] = useState<{ fixed: number; variable: number } | null>(null);
  const shown = pending ?? { fixed, variable };

  const commit = (next: { fixed: number; variable: number }) => {
    setPending(next);
    onSave(next.fixed, next.variable)
      .catch(() => {})
      .finally(() => setPending(null));
  };

  return (
    <>
      <span className="truncate text-sm text-text-primary">{label}</span>
      <HoursStepper
        label={`${name} fixed hours`}
        value={shown.fixed}
        min={0}
        onCommit={(hours) => commit({ ...shown, fixed: hours })}
      />
      <HoursStepper
        label={`${name} variable hours`}
        value={shown.variable}
        min={0}
        onCommit={(hours) => commit({ ...shown, variable: hours })}
      />
      {remove ? (
        <button
          type="button"
          aria-label={remove.label}
          onClick={remove.onClick}
          className="justify-self-center rounded-8 p-1 text-text-tertiary transition-colors hover:bg-foreground/[0.06] hover:text-text-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focus"
        >
          <X className="size-3.5" />
        </button>
      ) : (
        <span />
      )}
    </>
  );
}
